/* AUTO-GENERATED - COMPILED FROM TYPESCRIPT, DO NOT EDIT DIRECTLY */
(function() {
  "use strict";
  const EVENT_CATEGORY_QUIZ = "quiz";
  const EVENT_QUIZ_ACCESSED = "quiz_accessed";
  const EVENT_QUIZ_QUESTION_LOADED = "quiz_question_loaded";
  const EVENT_QUIZ_QUESTION_ANSWERED = "quiz_question_answered";
  const EVENT_QUIZ_COMPLETED = "quiz_completed";
  const EVENT_QUIZ_ADD_TO_CART = "quiz_add_to_cart";
  const EVENT_QUIZ_ADD_TO_CART_ERROR = "quiz_add_to_cart_error";
  const EVENT_QUIZ_VIEW_CART = "quiz_view_cart";
  const EVENT_QUIZ_GO_TO_CHECKOUT = "quiz_go_to_checkout";
  const EVENT_QUIZ_GO_TO_PRODUCT_PAGE = "quiz_go_to_product_page";
  const FIELD_QUIZ_SESSION_ID = "quiz_session_id";
  const FIELD_OCTANE_USER_ID = "octane_user_id";
  const FIELD_SHOP = "shop";
  const FIELD_QUIZ_EVENT = "quiz_event";
  const FIELD_QUEUED_TS = "queued_ts";
  const FIELD_ANSWERS = "answers";
  const FIELD_ANSWER_COUNT = "answer_count";
  const FIELD_QUIZ_RESULTS_URL = "quiz_results_url";
  const FIELD_AI_PERSONALIZED_MESSAGE = "ai_personalized_message";
  const FIELD_EMAIL_CONSENT = "email_consent";
  const FIELD_SMS_CONSENT = "sms_consent";
  const FIELD_HAS_EMAIL = "has_email";
  const FIELD_HAS_PHONE = "has_phone";
  const FIELD_EMAIL = "email";
  const FIELD_PHONE = "phone";
  const FIELD_SECTIONS = "sections";
  const FIELD_RECOMMENDED_PRODUCT_IDS = "recommended_product_ids";
  const FIELD_DATA = "data";
  const FIELD_QUESTION = "question";
  const FIELD_ANSWER = "answer";
  const FIELD_PAGE_TYPE = "page_type";
  const FIELD_PRODUCT = "product";
  const FIELD_PRODUCTS = "products";
  const FIELD_ERROR = "error";
  const DEDUPE_WINDOW_MS = 1e3;
  const SCRUB_DEPTH_LIMIT = 8;
  const TRANSPORT_POLL_MS = 100;
  const TRANSPORT_WAIT_MS = 5e3;
  const LOG_PREFIX = "[zyg-octane]";
  const STORAGE_KEY_SESSION_ID = "zyg_octane_sid";
  const STORAGE_KEY_USER_ID = "zyg_octane_uid";
  const STORAGE_PROBE_KEY = "__zyg_probe";
  const STORAGE_PROBE_VALUE = "1";
  const SCRUB_SENTINEL_CIRCULAR = "[circular]";
  const SCRUB_SENTINEL_MAX_DEPTH = "[max_depth]";
  const UUID_TEMPLATE = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
  const UUID_PLACEHOLDER_PATTERN = /[xy]/g;
  const UUID_CHAR_RANDOM = "x";
  const UUID_HEX_RADIX = 16;
  const UUID_VARIANT_MASK = 3;
  const UUID_VARIANT_BITS = 8;
  const StorageType = {
    SESSION: "sessionStorage",
    LOCAL: "localStorage"
  };
  const OctaneEventType = {
    ACCESSED: "octane.quiz.accessed",
    QUESTION_LOADED: "octane.quiz.questionLoaded",
    QUESTION_ANSWERED: "octane.quiz.questionAnswered",
    COMPLETED: "octane.quiz.completed",
    ADD_TO_CART: "octane.quiz.addToCart",
    ADD_TO_CART_ERROR: "octane.quiz.addToCartError",
    VIEW_CART: "octane.quiz.viewCart",
    GO_TO_CHECKOUT: "octane.quiz.goToCheckout",
    GO_TO_PRODUCT_PAGE: "octane.quiz.goToProductPage"
  };
  const AnalyticsEventName = {
    QUIZ_ACCESSED: EVENT_QUIZ_ACCESSED,
    QUIZ_QUESTION_LOADED: EVENT_QUIZ_QUESTION_LOADED,
    QUIZ_QUESTION_ANSWERED: EVENT_QUIZ_QUESTION_ANSWERED,
    QUIZ_COMPLETED: EVENT_QUIZ_COMPLETED,
    QUIZ_ADD_TO_CART: EVENT_QUIZ_ADD_TO_CART,
    QUIZ_ADD_TO_CART_ERROR: EVENT_QUIZ_ADD_TO_CART_ERROR,
    QUIZ_VIEW_CART: EVENT_QUIZ_VIEW_CART,
    QUIZ_GO_TO_CHECKOUT: EVENT_QUIZ_GO_TO_CHECKOUT,
    QUIZ_GO_TO_PRODUCT_PAGE: EVENT_QUIZ_GO_TO_PRODUCT_PAGE
  };
  const EVENT_MAP = /* @__PURE__ */ new Map([
    [OctaneEventType.ACCESSED, AnalyticsEventName.QUIZ_ACCESSED],
    [OctaneEventType.QUESTION_LOADED, AnalyticsEventName.QUIZ_QUESTION_LOADED],
    [OctaneEventType.QUESTION_ANSWERED, AnalyticsEventName.QUIZ_QUESTION_ANSWERED],
    [OctaneEventType.COMPLETED, AnalyticsEventName.QUIZ_COMPLETED],
    [OctaneEventType.ADD_TO_CART, AnalyticsEventName.QUIZ_ADD_TO_CART],
    [OctaneEventType.ADD_TO_CART_ERROR, AnalyticsEventName.QUIZ_ADD_TO_CART_ERROR],
    [OctaneEventType.VIEW_CART, AnalyticsEventName.QUIZ_VIEW_CART],
    [OctaneEventType.GO_TO_CHECKOUT, AnalyticsEventName.QUIZ_GO_TO_CHECKOUT],
    [OctaneEventType.GO_TO_PRODUCT_PAGE, AnalyticsEventName.QUIZ_GO_TO_PRODUCT_PAGE]
  ]);
  const SIGNATURE_SEPARATOR = "|";
  const SlimField = {
    ID: "id",
    TITLE: "title",
    PRICE: "price",
    LINK: "link",
    TYPE: "type",
    TAGS: "tags",
    NAME: "name",
    PRODUCTS: "products",
    VARIANT_IDS: "variant_ids",
    HAS_SELLING_PLANS: "has_selling_plans",
    PRODUCT_COUNT: "product_count"
  };
  const FieldCopyKind = {
    PRESENT: "present",
    FALLBACK: "fallback",
    PASSTHROUGH: "passthrough",
    FLAG: "flag"
  };
  const PayloadField = {
    QUIZ_SESSION_ID: FIELD_QUIZ_SESSION_ID,
    OCTANE_USER_ID: FIELD_OCTANE_USER_ID,
    SHOP: FIELD_SHOP,
    QUIZ_EVENT: FIELD_QUIZ_EVENT,
    QUEUED_TS: FIELD_QUEUED_TS,
    ANSWERS: FIELD_ANSWERS,
    ANSWER_COUNT: FIELD_ANSWER_COUNT,
    QUIZ_RESULTS_URL: FIELD_QUIZ_RESULTS_URL,
    AI_PERSONALIZED_MESSAGE: FIELD_AI_PERSONALIZED_MESSAGE,
    EMAIL_CONSENT: FIELD_EMAIL_CONSENT,
    SMS_CONSENT: FIELD_SMS_CONSENT,
    HAS_EMAIL: FIELD_HAS_EMAIL,
    HAS_PHONE: FIELD_HAS_PHONE,
    EMAIL: FIELD_EMAIL,
    PHONE: FIELD_PHONE,
    SECTIONS: FIELD_SECTIONS,
    RECOMMENDED_PRODUCT_IDS: FIELD_RECOMMENDED_PRODUCT_IDS,
    DATA: FIELD_DATA,
    QUESTION: FIELD_QUESTION,
    ANSWER: FIELD_ANSWER,
    PAGE_TYPE: FIELD_PAGE_TYPE,
    PRODUCT: FIELD_PRODUCT,
    PRODUCTS: FIELD_PRODUCTS,
    ERROR: FIELD_ERROR
  };
  const DetailField = {
    USER: "user",
    ANSWERS: "answers",
    QUIZ_RESULTS_URL: "quiz_results_url",
    AI_PERSONALIZED_MESSAGE: "ai_personalized_message",
    EMAIL_CONSENT: "email_consent",
    SMS_CONSENT: "sms_consent",
    PHONE_CONSENT: "phone_consent",
    EMAIL: "email",
    PHONE: "phone",
    SECTIONS: "sections",
    QUESTION: "question",
    ANSWER: "answer",
    PAGE_TYPE: "page_type",
    PRODUCT: "product",
    PRODUCTS: "products",
    ERROR: "error"
  };
  const SIGNATURE_PAYLOAD_FIELDS = [
    PayloadField.ANSWERS,
    PayloadField.QUIZ_RESULTS_URL,
    PayloadField.AI_PERSONALIZED_MESSAGE,
    PayloadField.EMAIL_CONSENT,
    PayloadField.SMS_CONSENT,
    PayloadField.SECTIONS,
    PayloadField.RECOMMENDED_PRODUCT_IDS,
    PayloadField.QUESTION,
    PayloadField.ANSWER,
    PayloadField.PAGE_TYPE,
    PayloadField.PRODUCT,
    PayloadField.PRODUCTS,
    PayloadField.ERROR
  ];
  const CONFIG = {
    category: EVENT_CATEGORY_QUIZ,
    slim: true,
    sendPII: false,
    dedupeWindowMs: DEDUPE_WINDOW_MS,
    debug: false
  };
  const WINDOW_PROP_SHOPIFY = "Shopify";
  const WINDOW_PROP_SAFE_TRACK_EVENT = "safeTrackEvent";
  const SMS_CONSENT_DETAIL_KEYS = [
    DetailField.SMS_CONSENT,
    DetailField.PHONE_CONSENT
  ];
  const OBJECT_SCRUB_RULES = [
    {
      match: (value) => typeof Node !== "undefined" && value instanceof Node,
      resolve: () => void 0
    },
    {
      match: (value) => value === window || typeof Window !== "undefined" && value instanceof Window,
      resolve: () => void 0
    },
    {
      match: (value) => typeof Event !== "undefined" && value instanceof Event,
      resolve: () => void 0
    },
    {
      match: (value) => value instanceof Date,
      resolve: (value) => value.toISOString()
    },
    {
      match: (_value, depth) => depth >= SCRUB_DEPTH_LIMIT,
      resolve: () => SCRUB_SENTINEL_MAX_DEPTH
    },
    {
      match: (value, _depth, seen) => seen.has(value),
      resolve: () => SCRUB_SENTINEL_CIRCULAR
    }
  ];
  const PROGRESS_FIELD_COPIES = [
    { kind: FieldCopyKind.PRESENT, from: DetailField.QUESTION, to: PayloadField.QUESTION },
    { kind: FieldCopyKind.PRESENT, from: DetailField.ANSWER, to: PayloadField.ANSWER },
    { kind: FieldCopyKind.PRESENT, from: DetailField.PAGE_TYPE, to: PayloadField.PAGE_TYPE }
  ];
  const COMPLETED_FIELD_COPIES = [
    {
      kind: FieldCopyKind.FALLBACK,
      from: DetailField.ANSWERS,
      to: PayloadField.ANSWERS,
      fallback: () => ({})
    },
    {
      kind: FieldCopyKind.FALLBACK,
      from: DetailField.QUIZ_RESULTS_URL,
      to: PayloadField.QUIZ_RESULTS_URL,
      fallback: () => null
    },
    {
      kind: FieldCopyKind.FALLBACK,
      from: DetailField.AI_PERSONALIZED_MESSAGE,
      to: PayloadField.AI_PERSONALIZED_MESSAGE,
      fallback: () => null
    },
    {
      kind: FieldCopyKind.PASSTHROUGH,
      from: DetailField.EMAIL_CONSENT,
      to: PayloadField.EMAIL_CONSENT
    },
    { kind: FieldCopyKind.FLAG, from: DetailField.EMAIL, to: PayloadField.HAS_EMAIL },
    { kind: FieldCopyKind.FLAG, from: DetailField.PHONE, to: PayloadField.HAS_PHONE }
  ];
  const PII_FIELD_COPIES = [
    {
      kind: FieldCopyKind.FALLBACK,
      from: DetailField.EMAIL,
      to: PayloadField.EMAIL,
      fallback: () => null
    },
    {
      kind: FieldCopyKind.FALLBACK,
      from: DetailField.PHONE,
      to: PayloadField.PHONE,
      fallback: () => null
    }
  ];
  const APPLY_FIELD_COPY = {
    [FieldCopyKind.PRESENT]: (out, copy, detail) => {
      const value = detail[copy.from];
      return Object.assign(
        out,
        value ? { [copy.to]: copy.transform ? copy.transform(value) : value } : {}
      );
    },
    [FieldCopyKind.FALLBACK]: (out, copy, detail) => {
      out[copy.to] = detail[copy.from] || copy.fallback();
      return out;
    },
    [FieldCopyKind.PASSTHROUGH]: (out, copy, detail) => {
      out[copy.to] = detail[copy.from];
      return out;
    },
    [FieldCopyKind.FLAG]: (out, copy, detail) => {
      out[copy.to] = !!detail[copy.from];
      return out;
    }
  };
  function windowProp(name) {
    return window[name];
  }
  function isTrackFn(value) {
    return typeof value === "function";
  }
  function isRecord(value) {
    return Boolean(value) && typeof value === "object";
  }
  function applyFieldCopy(out, copy, detail) {
    return APPLY_FIELD_COPY[copy.kind](out, copy, detail);
  }
  class ZygOctaneCollector {
    #config;
    #lastSeen = /* @__PURE__ */ new Map();
    #stores = /* @__PURE__ */ new Map();
    #assigners = /* @__PURE__ */ new Map([
      [OctaneEventType.COMPLETED, (payload, detail) => this.#completedDetail(payload, detail)]
    ]);
    #sessionId;
    #lateAbort;
    constructor(overrides = {}) {
      this.#config = { ...CONFIG, ...overrides };
    }
    /** Returns usable Web Storage, or null when the probe write is blocked. */
    probeStorage(type) {
      try {
        const store = window[type];
        store.setItem(STORAGE_PROBE_KEY, STORAGE_PROBE_VALUE);
        store.removeItem(STORAGE_PROBE_KEY);
        return store;
      } catch (error) {
        this.#log("storage probe failed", type, error);
        return null;
      }
    }
    /** Builds a UUID v4, preferring crypto.randomUUID. */
    createUuid() {
      try {
        return window.crypto.randomUUID();
      } catch (error) {
        this.#log("randomUUID unavailable", error);
        return this.#uuidV4Fallback();
      }
    }
    /** Drops DOM nodes, functions, cycles, and non-finite numbers from a value. */
    scrub(value, depth = 0, seen = /* @__PURE__ */ new WeakSet()) {
      if (value === null || value === void 0) {
        return value;
      }
      if (typeof value === "function" || typeof value === "symbol") {
        return void 0;
      }
      if (typeof value === "number") {
        return Number.isFinite(value) ? value : null;
      }
      if (typeof value !== "object") {
        return value;
      }
      return this.#scrubObject(value, depth, seen);
    }
    slimProduct(product) {
      if (!isRecord(product)) {
        return product;
      }
      const source = product;
      return {
        [SlimField.ID]: source.id,
        [SlimField.TITLE]: source.title,
        [SlimField.PRICE]: source.price,
        [SlimField.LINK]: source.link,
        [SlimField.TYPE]: source.type,
        [SlimField.TAGS]: source.tags,
        [SlimField.VARIANT_IDS]: (source.variants || []).map((variant) => variant && variant.id),
        [SlimField.HAS_SELLING_PLANS]: !!(source.selling_plans && source.selling_plans.length)
      };
    }
    /** Maps Octane result sections to slim product lists. */
    slimSections(sections) {
      return this.#hasItems(sections) ? sections.map((section) => this.#slimSection(section)) : [];
    }
    /** Builds the analytics payload for one Octane event. */
    buildDetail(octaneType, raw) {
      const scrubbed = this.scrub(raw);
      const detail = isRecord(scrubbed) ? scrubbed : {};
      const payload = this.#withUser(this.#baseContext(), detail);
      payload[PayloadField.QUIZ_EVENT] = octaneType;
      return (this.#assigners.get(octaneType) ?? this.#progressDetail.bind(this))(
        payload,
        detail
      );
    }
    /** True when the same event signature fired inside the dedupe window. */
    isDuplicate(name, payload) {
      const signature = this.#signature(name, payload);
      if (signature === void 0) {
        return false;
      }
      const now = Date.now();
      const lastAt = this.#lastSeen.get(signature);
      if (lastAt !== void 0 && now - lastAt < this.#config.dedupeWindowMs) {
        return true;
      }
      this.#lastSeen.set(signature, now);
      return false;
    }
    /** Resolves true once safeTrackEvent exists, or false when the wait expires. */
    waitForSafeTrackEvent(timeoutMs) {
      return this.#hasSafeTrackEvent() ? Promise.resolve(true) : this.#pollUntil(() => this.#hasSafeTrackEvent(), timeoutMs);
    }
    /** Scrubs, dedupes, and forwards one queued or live Octane event. */
    send(entry) {
      const name = EVENT_MAP.get(entry.type);
      if (!name) {
        return;
      }
      const payload = this.#payloadFrom(entry);
      if (!payload) {
        return;
      }
      if (this.isDuplicate(name, payload)) {
        this.#log("deduped", name);
        return;
      }
      this.#log("send", name, payload);
      this.#forward(name, payload);
    }
    /** Clears session, dedupe, and late-listener state so this instance can boot again. */
    reset() {
      this.#lateAbort?.abort();
      this.#lateAbort = void 0;
      this.#sessionId = void 0;
      this.#stores.clear();
      this.#lastSeen.clear();
    }
    /** Drains the head-stub queue, then takes over live push() / late listeners. */
    boot() {
      const queued = this.#queuedEntries();
      this.#installLiveQueue();
      this.#log("draining", queued.length, "queued events");
      queued.forEach((entry) => this.send(entry));
      if (!window.__zygOctaneStubInstalled) {
        this.#bindLateListeners();
      }
    }
    /** Waits for the analytics transport, then boots the collector. */
    async start() {
      this.#log("transport ready:", await this.waitForSafeTrackEvent(TRANSPORT_WAIT_MS));
      this.boot();
    }
    #uuidV4Fallback() {
      return UUID_TEMPLATE.replace(UUID_PLACEHOLDER_PATTERN, (char) => {
        const nibble = Math.random() * UUID_HEX_RADIX | 0;
        return (char === UUID_CHAR_RANDOM ? nibble : nibble & UUID_VARIANT_MASK | UUID_VARIANT_BITS).toString(UUID_HEX_RADIX);
      });
    }
    #scrubObject(value, depth, seen) {
      const rule = OBJECT_SCRUB_RULES.find(({ match }) => match(value, depth, seen));
      if (rule) {
        return rule.resolve(value);
      }
      seen.add(value);
      const scrubbed = Array.isArray(value) ? this.#scrubArray(value, depth, seen) : this.#scrubRecord(value, depth, seen);
      seen.delete(value);
      return scrubbed;
    }
    #scrubArray(value, depth, seen) {
      return value.map((item) => this.scrub(item, depth + 1, seen)).filter((scrubbed) => scrubbed !== void 0);
    }
    #scrubRecord(value, depth, seen) {
      return Object.fromEntries(
        Object.keys(value).flatMap((key) => {
          try {
            const scrubbed = this.scrub(
              value[key],
              depth + 1,
              seen
            );
            return scrubbed === void 0 ? [] : [[key, scrubbed]];
          } catch (error) {
            this.#log("scrub skipped", key, error);
            return [];
          }
        })
      );
    }
    #hasItems(value) {
      return Boolean(value && value.length);
    }
    #sectionProducts(section) {
      return section.products || [];
    }
    #slimProducts(products) {
      return products.map((product) => this.slimProduct(product));
    }
    #slimSection(section) {
      const products = this.#sectionProducts(section);
      return {
        [SlimField.ID]: section.id,
        [SlimField.NAME]: section.name,
        [SlimField.PRODUCT_COUNT]: products.length,
        [SlimField.PRODUCTS]: this.#slimProducts(products)
      };
    }
    #applySlim(value, slim) {
      return this.#config.slim ? slim(value) : value;
    }
    #assignFields(payload, detail, copies) {
      return copies.reduce((out, copy) => applyFieldCopy(out, copy, detail), payload);
    }
    #progressCopies() {
      return [
        ...PROGRESS_FIELD_COPIES,
        {
          kind: FieldCopyKind.PRESENT,
          from: DetailField.PRODUCT,
          to: PayloadField.PRODUCT,
          transform: (product) => this.#applySlim(product, (item) => this.slimProduct(item))
        },
        {
          kind: FieldCopyKind.PRESENT,
          from: DetailField.PRODUCTS,
          to: PayloadField.PRODUCTS,
          transform: (products) => this.#applySlim(
            products,
            (items) => this.#slimProducts(items || [])
          )
        },
        {
          kind: FieldCopyKind.PRESENT,
          from: DetailField.ERROR,
          to: PayloadField.ERROR,
          transform: (error) => String(error)
        }
      ];
    }
    #completedCopies() {
      return [...COMPLETED_FIELD_COPIES, ...this.#config.sendPII ? PII_FIELD_COPIES : []];
    }
    #progressDetail(payload, detail) {
      payload[PayloadField.DATA] = detail;
      return this.#assignFields(payload, detail, this.#progressCopies());
    }
    #completedDetail(payload, detail) {
      const withFields = this.#assignFields(payload, detail, this.#completedCopies());
      const sections = this.#applySlim(
        detail[DetailField.SECTIONS],
        (sectionList) => this.slimSections(sectionList)
      );
      withFields[PayloadField.ANSWER_COUNT] = Object.keys(
        withFields[PayloadField.ANSWERS]
      ).length;
      withFields[PayloadField.SMS_CONSENT] = this.#smsConsent(detail);
      withFields[PayloadField.SECTIONS] = sections;
      withFields[PayloadField.RECOMMENDED_PRODUCT_IDS] = this.#recommendedProductIds(sections);
      return withFields;
    }
    #smsConsent(detail) {
      return detail[SMS_CONSENT_DETAIL_KEYS.find((detailKey) => typeof detail[detailKey] !== "undefined") ?? DetailField.PHONE_CONSENT];
    }
    #recommendedProductIds(sections) {
      return (sections || []).flatMap(
        (section) => this.#sectionProducts(section).map((product) => product.id)
      );
    }
    #withUser(payload, detail) {
      const user = detail[DetailField.USER];
      if (!user) {
        return payload;
      }
      this.#setOctaneUserId(user);
      payload[PayloadField.OCTANE_USER_ID] = user;
      return payload;
    }
    #signature(name, payload) {
      try {
        return [
          name,
          JSON.stringify(SIGNATURE_PAYLOAD_FIELDS.map((field) => payload[field]))
        ].join(SIGNATURE_SEPARATOR);
      } catch (error) {
        this.#log("signature failed", name, error);
        return void 0;
      }
    }
    #payloadFrom(entry) {
      try {
        return this.#withQueuedTimestamp(this.buildDetail(entry.type, entry.detail), entry.ts);
      } catch (error) {
        this.#log("payload build failed", entry.type, error);
        return void 0;
      }
    }
    #withQueuedTimestamp(payload, queuedAt) {
      return Object.assign(
        payload,
        queuedAt ? { [PayloadField.QUEUED_TS]: new Date(queuedAt).toISOString() } : {}
      );
    }
    #forward(name, payload) {
      const transport = windowProp(WINDOW_PROP_SAFE_TRACK_EVENT);
      if (!isTrackFn(transport)) {
        this.#log("no transport available, dropping", name);
        return;
      }
      try {
        transport(this.#config.category, name, payload);
      } catch (error) {
        this.#log("send failed", name, error);
      }
    }
    #pollUntil(ready, timeoutMs) {
      return new Promise((resolve) => {
        let waited = 0;
        const interval = setInterval(() => {
          waited += TRANSPORT_POLL_MS;
          const isReady = ready();
          if (isReady || waited >= timeoutMs) {
            clearInterval(interval);
            resolve(isReady);
          }
        }, TRANSPORT_POLL_MS);
      });
    }
    #queuedEntries() {
      const queue = window.zygOctaneQueue;
      return queue && typeof queue.length === "number" ? Array.from(queue) : [];
    }
    #installLiveQueue() {
      window.zygOctaneQueue = {
        length: 0,
        push: (entry) => {
          this.send(entry);
          return 0;
        }
      };
    }
    #store(type) {
      if (!this.#stores.has(type)) {
        this.#stores.set(type, this.probeStorage(type));
      }
      return this.#stores.get(type) ?? null;
    }
    #ensureSessionId() {
      const store = this.#store(StorageType.SESSION);
      const existing = store?.getItem(STORAGE_KEY_SESSION_ID);
      if (existing) {
        this.#sessionId = existing;
        return existing;
      }
      this.#sessionId ??= this.createUuid();
      store?.setItem(STORAGE_KEY_SESSION_ID, this.#sessionId);
      return this.#sessionId;
    }
    #getOctaneUserId() {
      return this.#store(StorageType.LOCAL)?.getItem(STORAGE_KEY_USER_ID) ?? null;
    }
    #setOctaneUserId(id) {
      const store = this.#store(StorageType.LOCAL);
      if (store && id && id !== store.getItem(STORAGE_KEY_USER_ID)) {
        store.setItem(STORAGE_KEY_USER_ID, String(id));
      }
    }
    #getShop() {
      return windowProp(WINDOW_PROP_SHOPIFY)?.shop || window.location.hostname;
    }
    #baseContext() {
      return {
        [PayloadField.QUIZ_SESSION_ID]: this.#ensureSessionId(),
        [PayloadField.OCTANE_USER_ID]: this.#getOctaneUserId(),
        [PayloadField.SHOP]: this.#getShop()
      };
    }
    #hasSafeTrackEvent() {
      return isTrackFn(windowProp(WINDOW_PROP_SAFE_TRACK_EVENT));
    }
    #log(...args) {
      if (this.#config.debug && window.console) {
        console.debug(LOG_PREFIX, ...args);
      }
    }
    #bindLateListeners() {
      if (this.#lateAbort && !this.#lateAbort.signal.aborted) {
        return;
      }
      this.#lateAbort = new AbortController();
      this.#log("head stub missing, binding late");
      EVENT_MAP.forEach((_analyticsName, type) => {
        document.addEventListener(
          type,
          (event) => {
            this.send({
              type,
              detail: event.detail,
              ts: Date.now()
            });
          },
          { signal: this.#lateAbort?.signal }
        );
      });
    }
  }
  void new ZygOctaneCollector().start();
})();
